import React, { useEffect, useState } from 'react'
import PageHeader from '../helper/PageHeader';
import { useHistory } from 'react-router'
//import { authContext } from '../../context/AuthContext';
import Autocomplete from '@mui/material/Autocomplete';
//import { TextValidator } from 'react-material-ui-form-validator';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ListIcon from '@mui/icons-material/ViewList';
import PeopleIcon from '@mui/icons-material/People';
import Grid from '@mui/material/Grid';

import axios from 'axios';


const AdminEmployers = props => {
    const history = useHistory()   
    // const params = useParams()
    // const context = useContext(authContext)

    const [availableCredit, setAvailableCredit] = useState(null);
    const [data, setData] = useState(null);
    const [employerLocation, setEmployerLocation] = useState(null);

    const [employers, setEmployers] = useState([]);
    const [employer, setEmployer] = useState(null);

    const [username, setUserName] = useState(null);

    async function getEmployerData(employerID) {
     //   console.log(employerID);
        const res = await axios.all([
            axios.get('/api/usergroup/'+ employerID, {}),
            axios.get('/api/credit/log/'+ employerID, {})
        ])
    
        // console.log('res', res);
        setData(res[1].data);
        setAvailableCredit(res[0].data.usergroup.credit)
        setEmployerLocation(res[0].data.location)
    }

    useEffect(() => {
        if (employer)
            getEmployerData(employer.id);

    }, [employer])

    async function getEmployers() {
        const res = await axios.get('/api/usergroup/list/employer', {
        });

        // console.log('res employer', res);
        let employers = [];

        if (res.data.employers.length > 0) {
            res.data.employers.map((u) =>
                employers.push({ id: u.id, name: u.name, })
            )
        };
        setEmployers(employers);
        let selectedEmployer = JSON.parse(sessionStorage.getItem('adminSelectedEmployer'));
        // console.log(selectedEmployer);
        if (selectedEmployer) {
            // console.log(selectedEmployer.id)
            setEmployer({id:selectedEmployer.id, name: selectedEmployer.name} );
        }
    }

    useEffect(() => {
       
        

        getEmployers();

    },[])

    const onEmployerSelect = (name, value) => {

        // console.log('value', value)

        if (value === null){
            setData(null)
            setEmployer(null)
            setEmployerLocation(null)
            sessionStorage.removeItem('adminSelectedEmployer')
            getEmployers()
            setAvailableCredit(null)
            return 
        }

        let selected = value;

        if (selected === null) {
           // setEmployer({id: "", name:""});

          return;
        }
        setEmployer({id:selected.id, name: selected.name} );
        sessionStorage.setItem('adminSelectedEmployer', JSON.stringify(selected))

        getEmployerData(selected.id);
    }
  
    const creditHistoryClicked = () => {
        history.push('/administration/creditHistory/employer/'+ employer.id);
        
    }
    const purchaseHistoryClicked = () => {
        history.push('/administration/userPurchase/employer/'+ employer.id);
        
    }

    const employerAdminClicked = () => {
        // console.log('employer admin ');
        history.push('/administration/employer/admin/'+ employer.id);
        
    }

    const manageTraining = () => {
        history.push('/administration/employer/training/'+ employer.id);
        
    }
    const correctTraining = () => {
        history.push('/administration/employer/correctTraining/'+ employer.id);
        
    }
    const onChange = (e) => {
        setUserName(e.target.value)
        // console.log('target value', e.target.value)
    }

    const onSearchUser = async () => {
        // console.log('search clikced username', username)
        const res = await axios.get(' /api/groupUser/group/' + username, {
        });

        // console.log('res', res)

        let rest = res.data.groups
        let employers = [] 

        let filteredRest = rest.filter( data => data.type=== "Employer" )

        // console.log('filtered Rest', filteredRest)

        rest = filteredRest

        if (rest.length > 0) {
            rest.map((u) =>
                employers.push({ id: u.id, name: u.name, })
            )
        };
        // console.log('new employer', employers)
        setEmployers(employers);
        setEmployer(null)
        // let selectedEmployer = JSON.parse(sessionStorage.getItem('adminSelectedEmployer'));
        // console.log(selectedEmployer);
        // if (selectedEmployer) {
        //     console.log(selectedEmployer.id)
        //     setEmployer({id:selectedEmployer.id, name: selectedEmployer.name} );
        // }

    }

    const onClear = () => {
        setData(null)
        setEmployer(null)
        setUserName(null)
        sessionStorage.removeItem('adminSelectedEmployer')
        getEmployers()
        setAvailableCredit(null)
    }

    return <>
        <PageHeader title={"Manage Employers" }
            cancel={history.goBack} 
        />
            <Grid container spacing={3} >
                <Grid item xs={12}  md={4}>
                        <TextField
                            id="username"
                            label="(Optional) Enter a Username"
                            type="text"
                            className={[].join(' ')}
                            value={username || "" }
                            onChange = {onChange}
                            name='username'
                            fullWidth
                        />
                </Grid>
                <Grid item xs={12}  md={3} style={{ textAlign: "center", alignSelf: "flex-end", margin: 10 }}>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    className={[].join(' ')} 
                    onClick={ onSearchUser}
                >
                    Filter Employer List
                    </Button>
                </Grid>
                <Grid item xs={10}  md={1} style={{ textAlign: "center", alignSelf: "flex-end",  margin: 10 }}>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    className={[].join(' ')} 
                    onClick={ onClear }
                >
                    Clear
                    </Button>
                </Grid>
            </Grid>
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            <Grid item xs={12}  md={4}>
                <Autocomplete
                    id="employers"
                    options={employers}
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) => option.id === "" || value.id}
                    onChange={onEmployerSelect}
                    value={employer || null}
                    className={'class-admin-employers'}
                    renderInput={(params) => <TextField {...params} label="Select Employer" />}
                    disabled={employers.length === 0}
                />
          </Grid>
        </Grid>
        {employerLocation !== null &&
            <p>{employerLocation.STREET + ', ' + employerLocation.CITY + ', ' + employerLocation.STATECODE + ' ' + employerLocation.ZIPCODE}</p>
        }

        <p>Available Credit: {availableCredit}</p>
      
        {data === null ?  <h1>Please select an employer</h1>  :
            <>
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                 <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={employerAdminClicked}
                    startIcon={<PeopleIcon />}
                >
                    Employer Admin
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={manageTraining}
                    startIcon={<ListIcon />}
                >
                    Manage Training
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={correctTraining}
                    startIcon={<ListIcon />}
                >
                    Correct Previous Training
                </Button>
                 <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={creditHistoryClicked}
                    startIcon={<ListIcon />}
                >
                    Purchase History
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={purchaseHistoryClicked}
                    startIcon={<ListIcon />}
                >
                    Payments
                </Button>
                </Grid>
                
            </>
        }

    </>;
}

export default AdminEmployers;
